import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { getFormattedNumber } from '@ecg-marktplaats/aurora-js-formatters';

import Classes from './UserReviewsHeader.scss';

type TUserReviewsHeaderProps = {
  name: string;
  numberOfReviews: number;
  rating: number;
  activeSinceDiff?: string;
};

const UserReviewsHeader = ({ name, numberOfReviews, rating, activeSinceDiff }: TUserReviewsHeaderProps) => {
  const { t } = useI18nContext();

  const formattedNumberOfReviews = getFormattedNumber(numberOfReviews);

  return (
    <div className={Classes.root}>
      <h4 className={Classes.headerTitle}>{name}</h4>

      {!!activeSinceDiff && <p>{t('userReviews.activeOn', { activeSinceDiff })}</p>}

      <div className={Classes.totalReviewsContainer}>
        <Icon className={Classes.reviewIcon} name="saved" color="text-brand-primary" />
        <p>
          <span className={Classes.ratingTotal}>{rating.toFixed(1)}</span>
          {` · ${formattedNumberOfReviews} ${t('userReviews.review', { count: numberOfReviews })}`}
        </p>
      </div>
    </div>
  );
};

export default UserReviewsHeader;
